import { motion } from "framer-motion";
import { PhoneFrame } from "../devices/PhoneFrame";

export const ProductPhone = ({ src, alt, testId, className = "", rotate = 0, children }) => (
  <motion.div
    className={`feature-phone-wrap ${className}`}
    initial={{ opacity: 0, y: 50, rotate: rotate * 1.8 }}
    whileInView={{ opacity: 1, y: 0, rotate }}
    viewport={{ once: true, amount: .18 }}
    transition={{ duration: .8, ease: [.22, 1, .36, 1] }}
  >
    <PhoneFrame className="feature-phone" tilt testId={testId}>
      {src ? <img src={src} alt={alt} loading="lazy" className="feature-phone-image" /> : children}
    </PhoneFrame>
  </motion.div>
);

export const FeatureSection = ({ id, index, label, title, copy, reverse = false, dark = false, className = "", children, aside }) => (
  <section
    id={id}
    data-testid={`feature-section-${id}`}
    className={`feature-product-section ${dark ? "feature-section-dark" : ""} ${className}`}
  >
    <div className={`features-shell feature-section-grid ${reverse ? "feature-section-reverse" : ""}`}>
      <motion.div
        className="feature-copy"
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: .25 }}
        transition={{ duration: .7, ease: [.22, 1, .36, 1] }}
      >
        <p className="feature-index" data-testid={`${id}-section-label`}>{String(index).padStart(2, "0")} · {label}</p>
        <h2 data-testid={`${id}-section-title`}>{title}</h2>
        <p className="feature-description" data-testid={`${id}-section-copy`}>{copy}</p>
        {aside}
      </motion.div>
      <div className="feature-visual" data-testid={`${id}-visual`}>{children}</div>
    </div>
  </section>
);

export const FloatingNote = ({ eyebrow, title, detail, className = "", testId }) => (
  <motion.div
    className={`feature-floating-note ${className}`}
    initial={{ opacity: 0, y: 14, scale: .96 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true }}
    transition={{ delay: .25, duration: .55 }}
    data-testid={testId}
  >
    <small>{eyebrow}</small><strong>{title}</strong>{detail && <span>{detail}</span>}
  </motion.div>
);